"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextColor = void 0;
var TextColor;
(function (TextColor) {
    TextColor["textDark"] = "text-dark";
    TextColor["textBody"] = "text-body";
    TextColor["textMuted"] = "text-muted";
    TextColor["textPale"] = "text-pale";
    TextColor["textLight"] = "text-light";
    TextColor["textPrimary"] = "text-primary";
    TextColor["textSuccess"] = "text-success";
    TextColor["textDanger"] = "text-danger";
    TextColor["textWarning"] = "text-warning";
    TextColor["textInfo"] = "text-info";
    TextColor["textPurple"] = "text-purple";
    TextColor["textWhite"] = "text-white";
    TextColor["textIvory"] = "text-ivory";
    TextColor["textSecondary"] = "text-secondary";
    TextColor["textPublication"] = "text-publication";
    TextColor["textReset"] = "text-reset";
})(TextColor || (exports.TextColor = TextColor = {}));
